import RadioGroup from "../inputs/RadioGroup";
import { RadioGroupFieldsetProps } from "./FieldsetProps";
import { RadioButtonField } from "../inputs/InputProps";

import "./Fieldset.scss";

const StandardSize: React.FC<RadioGroupFieldsetProps> = ({ currentSelection, setCurrentSelection }) => {
    const fields: RadioButtonField[] = [
        {
            id: "0",
            label: "Yes, all pages of the document conform to standards described.",
        },
        {
            id: "1",
            label: "No, there is at least 1 page of the document that does not conform to standards as described.",
        },
    ];

    return (
        <fieldset className="fee-calc-fieldset">
            <legend>
                <i className="fa fa-asterisk" aria-hidden="true" title="Required"></i>
                <span className="sr-only">Required</span>
                All documents recorded are to be 8 ½ inches x 11 inches, single thickness to be considered a conforming
                page (
                <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=27361.&lawCode=GOV"
                >
                    <abbr title="Government Code">GC</abbr>27361(a)(2)
                </a>{" "}
                &{" "}
                <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=27361.5.&lawCode=GOV"
                >
                    <abbr title="Government Code">GC</abbr>27361.5
                </a>
                ).
            </legend>
            <RadioGroup
                currentSelection={currentSelection}
                setCurrentSelection={setCurrentSelection}
                fieldsetId="StandardSizeBase"
                fields={fields}
            />
        </fieldset>
    );
};

export default StandardSize;
